__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-25-1772022421-stable-dev/";